import { render } from "./ProductsList.vue?vue&type=template&id=c7d22338&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=c7d22338&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d22338"]])

export default __exports__